<template>
    <b-form inline @submit.prevent="search" class="d-inline-block mr-2">
        <b-form-group size="sm">
            <fup-input :style="{'max-width': minimize ? '10rem' : 'none'}"
                       size="sm"
                       placeholder="Поиск"
                       :value="value"
                       @input="input">
                <template slot="append">
                    <fup-button size="sm" variant="warning" type="submit">
                        <fup-icon name="search"/>
                    </fup-button>
                </template>
            </fup-input>
        </b-form-group>
    </b-form>
</template>

<script>
    export default {
        name: "TableHeaderSearcher",
        props: {
            value: null,
            minimize: false
        },
        data: () => {return {q: null}},
        methods: {
            search() {
                this.$emit('search', this.$data.q);
            },
            input(value) {
                this.$data.q = value;
                this.$emit('input', value);
            },
        },
    }
</script>